// extracted by mini-css-extract-plugin
export default {"container":"GDPRConsent_container__T-vYn","content":"GDPRConsent_content__VYwLe","title":"GDPRConsent_title__NW7xs","consentContainer":"GDPRConsent_consentContainer__ElZHu"};